module.exports = __webpack_public_path__ + "static/img/9.c08d940.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/sp/9.png
// module id = tCNN
// module chunks = 0